export const messages = {
  en: {
    shareReadingFee: {
      search: {
        title: 'Search Conditions',
        roomName: 'Please enter room number',
        ownerName: 'Please enter owner name'
      },
      list: {
        title: 'Shared Reading Fees'
      },
      table: {
        roomName: 'Room',
        ownerName: 'Owner',
        feeName: 'Fee Name',
        degrees: 'Shared Degrees',
        amount: 'Shared Amount',
        remark: 'Remark'
      },
      fetchError: 'Failed to fetch shared reading fees'
    }
  },
  zh: {
    shareReadingFee: {
      search: {
        title: '查询条件',
        roomName: '请输入房屋编号',
        ownerName: '请输入业主姓名'
      },
      list: {
        title: '公摊费用'
      },
      table: {
        roomName: '房屋',
        ownerName: '业主',
        feeName: '费用名称',
        degrees: '公摊度数',
        amount: '公摊金额',
        remark: '说明'
      },
      fetchError: '获取公摊费用失败'
    }
  },
  'zh-TW': {
    shareReadingFee: {
      search: {
        title: '查詢條件',
        roomName: '請輸入房屋編號',
        ownerName: '請輸入業主姓名'
      },
      list: {
        title: '公攤費用'
      },
      table: {
        roomName: '房屋',
        ownerName: '業主',
        feeName: '費用名稱',
        degrees: '公攤度數',
        amount: '公攤金額',
        remark: '說明'
      },
      fetchError: '獲取公攤費用失敗'
    }
  }
}